var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"pa-5 caption text--secondary",attrs:{"justify-center":""}},[_vm._v(" "+_vm._s(_vm.text || _vm.$t("common.no-data"))+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }